<template>
  <button
    v-loading="isLoading"
    class="btn-bh-button"
    :class="{ 'is-disabled': isDisable, 'w-80': statusWidth }"
    ref="btn-button"
    @click="onClickActionButton()"
    :disabled="isDisable"
    :style="{
      background: codeBackground,
      color: codeText,
      fontWeight: numberWeight,
    }"
  >
    <span class="text-center font-semibold text-lg text-white">{{
      nameButton
    }}</span>

    <img :src="urlImageIcon" alt="" />
  </button>
</template>

<script>
export default {
  name: "bh-button-v1",

  data() {
    return {};
  },

  props: {
    nameButtonDefault: String, // Xét tên button
    statusLoading: Boolean, // Xét Loading
    statusDisable: Boolean, // Xét nút Disable
    urlImage: String, // Xét Url icon
    statusWidth: Boolean, // Xét chiểu rộng
    codeColorBg: String, // Mã màu Background Button
    codeColorText: String, // Mã màu text button
    numberWeightBold: Number, // Độ đậm
  },

  computed: {
    nameButton() {
      return this.nameButtonDefault;
    },

    isLoading() {
      return this.statusLoading ? true : false;
    },

    isDisable() {
      return this.statusDisable ? true : false;
    },

    urlImageIcon() {
      return this.urlImage;
    },

    isWidth() {
      return this.statusWidth;
    },

    codeBackground() {
      return this.codeColorBg;
    },

    codeText() {
      return this.codeColorText;
    },

    numberWeight() {
      return this.numberWeightBold;
    },
  },

  mounted() {},

  methods: {
    /**
     * Xử lý sự kiện button
     */
    onClickActionButton() {
      this.$emit("onChangeActionButton", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-bh-button {
  padding: 8px 20px;
  border-radius: 30px;
  font-weight: 500;
  text-align: center;
  line-height: 1;
  letter-spacing: 0.5px;
  overflow: hidden;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to top right, #4a88d9, #052da6);
  background-clip: border-box;
  background-origin: border-box;
}

.btn-bh-button:hover {
  color: #ffffff;
  background: linear-gradient(to top right, #3564a1, #285bc0);
}

.is-disabled,
.is-disabled:hover {
  cursor: not-allowed;
  background-image: none;
  background: linear-gradient(to top right, #b0b9c5, #707790) !important;
  border: none;
}
</style>
